import { render } from "./VertragBanner.vue?vue&type=template&id=987c7578"
import script from "./VertragBanner.vue?vue&type=script&lang=js"
export * from "./VertragBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__